import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';
import { DgOrgSearchComponent } from 'dg-org-search-lib';

import moment from 'moment';
import { Subject } from 'rxjs';
import { Combo } from 'src/app/digigov/models/combo.model';
import { Response } from 'src/app/digigov/models/response.model';
import { IntermediateSaveService } from 'src/app/digigov/services/intermediate-save.service';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss'],
})
export class UserRegistrationComponent implements OnInit, AfterViewInit {
  @ViewChild('empSearch', { static: true })
  empSearch: DgEmployeeSearchComponent;
  @ViewChild('orgSearch', { static: true })
  orgSearch: DgOrgSearchComponent;
  addressData = [];
  addressCode = '';
  serviceYears = 58;
  tempEmp = [];
  tempOrg = [];

  testEmp = [
    {
      DSGN_ID: 3000021,
      EMP_ID: 3000891,
      FULL_NAME: 'Arif Mohammad Khan ',
      ORG_NAME: 'Law',
      POST_ID: 3002441,
      UNIT_ID: 3001660,
      UNIT_LEVEL: 75,
      UNIT_NAME: 'GOVERNOR',
      USER_NAME: 'GOVERNOR_KERALA',
    },
  ];
  //counts chracters in description
  maxChars = 200;
  desc = '';
  chars = 0;
  //Specific to Profile Component
  profileAttachTitle = '';
  isProfileComponent = true;
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 5000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = true;
  profileAttachID = '';
  @Output() closeTabEmit = new EventEmitter<boolean>();
  multiselect = false;
  observeVariable: Subject<any> = new Subject();
  expForm: FormGroup;
  selectedOrganization: any;

  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: true,
    header: 'Reporting Organization',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  empSearchConfig = {
    multiSelect: false,
    header: 'Reporting_Employee',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
  };

  selectedEmployees: string;
  selectedGen: number;
  pipe = new DatePipe('en-IN');
  attachemnt: string;
  salutationList: any[];
  @Input() data: any;
  content: any;
  public toggle_arr: boolean[] = [];

  roleList = [
    //{ value: 'Business Analyst' },
    //{ value: 'Consultant' },
    { value: 'Technical-Lead' },
    { value: 'Senior Developer' },
    { value: 'Senior Architect' },
    { value: 'UX Designer' },
    { value: 'Backend Developer' },
  ];
  selectedRole = [];
  isRefresh = false;

  selectedSalutation: any;
  showButtons = true;
  saveData: any = {
    addressDtlVO: null,
    extendedVO: null,
    customXidBean: null,
    dbSchema: null,
    empServiceFlag: 1,
    langId: null,
    crtPost: null,
    empId: null,
    empNo: null,
    empPhotoAttachId: null,
    empSignAttachId: null,
    locId: null,
    userEmpId: null,
    emailID: null,
    empDOB: null,
    empDOJ: null,
    empFirstName: null,
    empFullName: null,
    empLanguagesIdEntry: null,
    empLanguagesNameEntry: null,
    empLastName: null,
    empLoginName: null,
    employeeClass: null,
    employeeSubType: null,
    employeeType: null,
    empMiddleName: null,
    empName_4: null,
    empName_5: null,
    empName_6: null,
    empuniqueId: null,
    endDate: null,
    salutation: null,
    serviceExpiryDate: null,
    startDate: null,
    suffix: null,
    title: null,
    genderId: 1,
    fieldId: null,
    operation: null,
    value1: null,
    value2: null,
    activeFlag: null,
    activeFlagStatus: null,
    fromOrgChart: null,
    paginationVO: null,
    userName: null,
    userId: null,
    userEmpMpgId: null,
    repId: null,
    repType: null,
    asAPIFlag: true,
    dateRetirement: null,
    empIsPCS: null,

    biometricId: null,
    biometricKey: null,
    enableThumbAuthentication: false,
    empFirstNameLL: null,
    empLastNameLL: null,
    empMiddleNameLL: null,
    digSignatureSerialNo: null,
    mobile_no: 0,
    templateBase64: null,
    templateBase64Str: null,
    isWebAPI: false,
    orgName: null,
    objDscEmpMpgVO: null,
    actionScheduleId: null,
    className: null,
    message: '',
    placeholderData: null,
    actionId: null,
    appTypeID: 0,
    requestId: null,
  };
  postData: any = {
    addressDtlVO: null,
    empId: null,
    empDtlsId: null,
    empDOB: null,
    dateOfBirth: '',
    empFirstName: null,
    empMiddleName: null,
    empLastName: null,
    salutation: null,
    reportingEmpId: null,
    reportingOrgId: null,
    caseId: null,
    mobileNo: null,
    activeFlag: 1,
    isApproved: 1,
    status: 2,
    gender: null,
    role: '',
    address: null,
    photoAttachId: null,
    langId: null,
    crtPost: null,
    lstUpdatedPost: null,
    strCrtDate: null,
    strLstUpdatedDate: null,
    crtDate: null,
    lstUpdatedDate: null,
    attachmentReference: null,
    locId: null,
    deptId: null,
  };
  roleCheckboxModel = 'Business Analyst';
  existingEmployeeUnitList = [];
  constructor(
    private http: HttpClient,
    private saveService: IntermediateSaveService,
    public datePipe: DatePipe
  ) {
    for (let i = 0; i < this.roleList.length; i++) {
      this.roleList[i]['isChecked'] = false;
    }
  }
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.expForm = new FormGroup({
      empFirstName: new FormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z-,]+(\\s{0,1}[a-zA-Z-,])*$'),
      ]),
      empMiddleName: new FormControl(null, [
        Validators.pattern('^[a-zA-Z-,]+(\\s{0,1}[a-zA-Z-,])*$'),
      ]),
      empLastName: new FormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z-,]+(\\s{0,1}[a-zA-Z-,])*$'),
      ]),
      //address: new FormControl(''),
      mobileNo: new FormControl(''),
      gender: new FormControl('', [Validators.required]),
      salutation: new FormControl(''),
      role: new FormControl(''),
      reportingEmp: new FormControl(null, Validators.required),
      reportingDept: new FormControl(null),
      dob: new FormControl(new Date(), Validators.required),
      dor: new FormControl(null),
      addressDtlVO: new FormControl(null),
      empId: new FormControl(null),
    });

    this.populateSalutation();
    if (this.saveService.isFromInterSave) {
      const draftData = this.saveService.getJasonData();
      this.saveService.isFromInterSave = false;
      const formResData = draftData;

      if (draftData) {
        this.populateSalutationForSave(formResData.salutation);

        this.expForm.controls['empFirstName'].setValue(
          formResData.empFirstName
        );
        this.expForm.controls['empMiddleName'].setValue(
          formResData.empMiddleName
        );
        this.expForm.controls['empLastName'].setValue(formResData.empLastName);
        this.tempEmp = formResData.reportingEmpId;

        this.tempOrg = formResData.reportingOrgId;
        this.desc = String(formResData.address);

        this.expForm.controls['mobileNo'].setValue(formResData.mobileNo);

        this.expForm.controls['dob'].setValue(
          new Date(formResData.dateOfBirth)
        );
        this.selectedGen = formResData.gender;
        this.profileAttachID = formResData.photoAttachId;
        setTimeout(() => {
          for (let i = 0; i < this.roleList.length; i++) {
            if (formResData.role.includes(this.roleList[i].value)) {
              this.roleList[i]['isChecked'] = true;
              this.selectedRole.push(this.roleList[i].value);
            }
          }
        }, 1000);
        if (
          formResData?.reportingEmpId ||
          formResData?.reportingEmpId?.length > 0
        ) {
          let empList = Array.isArray(formResData?.reportingEmpId)
            ? formResData?.reportingEmpId
            : [formResData?.reportingEmpId];
          this.existingEmployeeUnitList = empList?.map((e) => e?.UNIT_ID);
        }
      }
    }
    if (this.data) {
      this.showButtons = false;
      this.http
        .get('/registration/employees/fileId/' + <string>this.data.docId)
        .subscribe(
          (res: Response<any>) => {
            this.content = res.data;
            this.expForm.controls['empFirstName'].setValue(
              this.content.empFirstName
            );
            this.expForm.controls['empMiddleName'].setValue(
              this.content.empMiddleName
            );
            this.expForm.controls['empLastName'].setValue(
              this.content.empLastName
            );
            // this.expForm.controls['address'].setValue(this.content.address);
            this.expForm.controls['mobileNo'].setValue(this.content.mobileNo);

            this.expForm.controls['empId'].setValue(this.content.empId);

            this.addressCode = this.content?.addressDtlVO?.addressCode;

            // const index = this.salutationList.findIndex(
            //   (x) => x.optionValue == this.content.salutation
            // );
            //this will set value

            this.selectedSalutation = 'Mr.';
            this.expForm.controls['dob'].setValue(
              moment(this.content.dateOfBirth)
            );
            this.selectedGen = this.content.gender;
            if (this.content.photoAttachId) {
              this.profileAttachID = this.content.photoAttachId;
            }

            this.observeVariable.next(this.content);
          },
          (err) => {
            console.error(err);
          }
        );
    }

    this.onValueChanges();
  }
  getOrgData(val): void {
    this.selectedOrganization = JSON.stringify(val);
    this.expForm.controls['reportingDept'].setValue(val);
  }

  getEmpData(val): void {
    this.selectedEmployees = JSON.stringify(val);
    this.expForm.controls['reportingEmp'].setValue(val);
  }
  onFinalPathForProfile(finalPath: string): void {
    this.attachemnt = finalPath;
  }
  submit(): void {
    let empList = this.expForm.controls['reportingEmp'].value
      ? Array.isArray(this.expForm.controls['reportingEmp'].value)
        ? this.expForm.controls['reportingEmp'].value
        : [this.expForm.controls['reportingEmp'].value]
      : null;
    this.postData.empFirstName = this.expForm.controls['empFirstName'].value;
    this.postData.empMiddleName = this.expForm.controls['empMiddleName'].value;
    this.postData.empLastName = this.expForm.controls['empLastName'].value;
    if (this.expForm.controls['salutation'].value) {
      this.postData.salutation = Number(
        this.expForm.controls['salutation'].value.optionValue
      );
    }
    this.postData.reportingEmpId = empList ? empList?.[0]?.EMP_ID : null;
    this.postData.reportingOrgId = null; //as not being use now

    // this.postData.reportingEmpId = this.empSearch.selectedEmployee;
    // this.postData.reportingOrgId = this.orgSearch.selectedOrganizations;

    this.postData.mobileNo = Number(this.expForm.controls['mobileNo'].value);
    this.postData.gender = Number(this.expForm.controls['gender'].value);

    const address = {
      addressFieldVOList: this.addressData,
      addressCode: this.addressCode,
    };
    this.postData.addressDtlVO = null; //as not being use now

    this.postData.address = null; //as not being use now

    this.postData.attachmentReference = this.attachemnt ? this.attachemnt : '';

    this.postData.empDOB = this.datePipe.transform(
      this.expForm.controls['dob'].value,
      'd-MMM-yyyy HH:mm:ss'
    );
    this.postData.empDOR = this.datePipe.transform(
      this.expForm.controls['dor'].value,
      'd-MMM-yyyy HH:mm:ss'
    );

    if (this.selectedRole) {
      const str = this.selectedRole.join();
      this.postData.role = str;
    }
    if (this.saveService.getReqTrnId()) {
      this.postData.reqTrnId = this.saveService.getReqTrnId();
    } else {
      this.postData.reqTrnId = null;
    }

    this.http.post('/registration/employees', this.postData).subscribe(() => {
      this.closeTabEmit.emit(true);
      this.saveService.setReqTrnId(null);
      this.onReset();
    });
  }
  saveAsDraft() {
    const address = {
      addressFieldVOList: this.addressData,
      addressCode: this.addressCode,
    };
    this.saveData.addressDtlVO = address;

    this.saveData.empFirstName = this.expForm.controls['empFirstName'].value
      ? this.expForm.controls['empFirstName'].value
      : null;
    this.saveData.empMiddleName = this.expForm.controls['empMiddleName'].value
      ? this.expForm.controls['empMiddleName'].value
      : null;
    this.saveData.empLastName = this.expForm.controls['empLastName'].value
      ? this.expForm.controls['empLastName'].value
      : null;
    this.saveData.salutation =
      this.expForm.controls['salutation'].value &&
      Number(this.expForm.controls['salutation'].value.optionValue)
        ? Number(this.expForm.controls['salutation'].value.optionValue)
        : null;
    this.saveData.reportingEmpId = this.empSearch?.selectedEmployee
      ? this.empSearch?.selectedEmployee
      : null;
    this.saveData.reportingOrgId = this.orgSearch?.selectedOrganizations
      ? this.orgSearch?.selectedOrganizations
      : null;
    this.saveData.mobileNo = this.expForm.controls['mobileNo'].value
      ? this.expForm.controls['mobileNo'].value
      : null;
    this.saveData.gender = this.expForm.controls['gender'].value
      ? this.expForm.controls['gender'].value
      : null;

    this.saveData.dateOfRetirement = this.datePipe.transform(
      this.expForm.controls['dor'].value,
      'd-MMM-yyyy HH:mm:ss'
    );
    this.saveData.attachmentReference = this.attachemnt;

    if (this.saveData.attachmentReference) {
      this.saveData.photoAttachId = null;
    } else {
      this.saveData.photoAttachId = this.profileAttachID
        ? this.profileAttachID
        : null;
    }

    this.saveData.dateOfBirth = this.expForm.controls['dob'].value
      ? this.expForm.controls['dob'].value
      : null;
    const str = this.selectedRole.join();
    this.saveData.role = str;

    const reqObj = {
      jsonData: this.saveData,
    };
    if (this.saveService.getReqTrnId()) {
      this.saveData.reqTrnId = this.saveService.getReqTrnId();
    } else {
      this.saveData.reqTrnId = null;
    }
    this.http
      .post('/registration/intermediate-save-employees', reqObj)
      .subscribe(() => {
        this.closeTabEmit.emit(true);
        this.saveService.setReqTrnId(null);
        this.onReset();
      });
  }
  populateSalutationForSave(salutation) {
    const dataforpost = {
      ComboId: '310',
    };
    this.http
      .post('/worklist/get-combo-list', dataforpost)
      .subscribe((res: Response<Combo[]>) => {
        this.salutationList = res.data;
        const index = this.salutationList.findIndex(
          (x) => x.optionValue == salutation
        );

        if (index > -1) {
          this.selectedSalutation = this.salutationList[index].optionText;
          this.expForm.controls['salutation'].setValue(
            this.salutationList[index]
          );
        }
      });
  }

  onReset(): void {
    this.expForm.reset();
    this.empSearch.reset();
    this.desc = '';
    this.maxChars = 200;
    this.selectedRole = [];
    this.refreshComponent();
  }
  onCancel(): void {
    this.closeTabEmit.emit(false);
  }

  populateSalutation(): void {
    const dataforpost = {
      ComboId: '310',
    };
    this.http
      .post('/worklist/get-combo-list', dataforpost)
      .subscribe((res: Response<Combo[]>) => {
        this.salutationList = res.data;
      });
  }

  onValueChanges(): void {
    this.expForm.valueChanges.subscribe(() => {
      this.observeVariable.next(this.expForm.value);
    });
  }
  refreshComponent(): void {
    //call this method when it is required to refresh the Attachment component
    if (this.isRefresh) {
      this.isRefresh = false;
    } else if (!this.isRefresh) {
      this.isRefresh = true;
    }
  }
  toggle(event: string): void {
    if (!this.selectedRole.includes(event)) {
      this.selectedRole.push(event);
    } else {
      const index: number = this.selectedRole.indexOf(event);
      if (index !== -1) {
        this.selectedRole.splice(index, 1);
      }
    }
  }
  getAddressOutput(event): void {
    this.addressData = event;
    if (this.addressData.length) {
      if (this.addressCode) {
        let address = {
          addressFieldVOList: this.addressData,
          addressCode: this.addressCode,
        };
        this.expForm.controls['addressDtlVO'].setValue(address);
      }
    }
  }
}
